import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { primaryBlockDefaultStyles } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import { useTopBlockStyles } from "@circle-react-shared/BuilderUI/Hooks/useTopBlockStyles";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export interface PlanCardBlockProps
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  button?: ReactNode;
  content?: ReactNode;
  header?: ReactNode;
  price?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const PlanCardBlock = forwardRef<HTMLDivElement, PlanCardBlockProps>(
  ({ header, price, button, content, styles, className, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background
          className="wb-border wb-rounded-xl wb-shadow wb-bg-primary"
          style={backgroundStyles}
        >
          <BlockSection.Content
            style={{
              ...paddingStyles,
              ...marginStyles,
            }}
          >
            <div className="wb-flex wb-flex-col wb-gap-6 wb-w-full">
              <BlockSection.NestedBlock>{header}</BlockSection.NestedBlock>
              <BlockSection.NestedBlock className="wb-flex wb-items-end wb-gap-2">
                {price}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock>{button}</BlockSection.NestedBlock>
              <BlockSection.NestedBlock>{content}</BlockSection.NestedBlock>
            </div>
          </BlockSection.Content>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

PlanCardBlock.displayName = "PlanCardBlock";
